<template>
  <div>
    <!-- 密码修改 -->
    <a-modal
      title="密码修改"
      :keyboard="false"
      :maskClosable="false"
      :closable="false"
      :confirmLoading="loading"
      :cancelButtonProps="{ props: { disabled: loading } }"
      v-model="show"
      @cancel="cancelUpdatePassword"
      @ok="handleUpdatePassword"
    >
      <a-form
        :autoFormCreate="
          form => {
            this.form = form;
          }
        "
      >
        <a-form-item
          label="旧密码"
          v-bind="formItemLayout"
          fieldDecoratorId="oldPassword"
          :fieldDecoratorOptions="{
            rules: [
              { required: true, message: '请输入旧密码' },
              { validator: this.handleOldPassowrd },
            ],
            validateTrigger: ['blur'],
          }"
        >
          <a-input
            type="password"
            autocomplete="false"
            v-model="oldPassword"
            placeholder="请输入旧密码"
          ></a-input>
        </a-form-item>
        <a-popover
          placement="rightTop"
          trigger="click"
          :visible="state.passwordLevelChecked"
        >
          <template slot="content">
            <div :style="{ width: '240px' }">
              <div :class="['update-password', passwordLevelClass]">
                强度：<span>{{ passwordLevelName }}</span>
              </div>
              <a-progress
                :percent="state.percent"
                :showInfo="false"
                :strokeColor="passwordLevelColor"
              />
              <div style="margin-top: 10px;">
                <span>请至少输入 6 个字符。请不要使用容易被猜到的密码。</span>
              </div>
            </div>
          </template>
          <a-form-item
            label="新密码"
            v-bind="formItemLayout"
            fieldDecoratorId="password"
            :fieldDecoratorOptions="{
              rules: [
                { required: true, message: '至少6位密码，区分大小写' },
                { min: 6, message: '至少6位密码，区分大小写' },
                { validator: this.handlePasswordLevel },
              ],
              validateTrigger: ['change', 'blur'],
            }"
          >
            <a-input
              type="password"
              @click="handlePasswordInputClick"
              v-model="newPassword"
              autocomplete="false"
              placeholder="至少6位密码，区分大小写"
            ></a-input>
          </a-form-item>
        </a-popover>
        <a-form-item
          label="再次确认"
          v-bind="formItemLayout"
          fieldDecoratorId="password2"
          :fieldDecoratorOptions="{
            rules: [
              { required: true, message: '至少6位密码，区分大小写' },
              { validator: this.handlePasswordCheck },
            ],
            validateTrigger: ['change', 'blur'],
          }"
        >
          <a-input
            type="password"
            autocomplete="false"
            placeholder="确认密码"
          ></a-input>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { encrypt } from 'utils/common';

const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 18 },
};
const levelNames = {
  0: '低',
  1: '低',
  2: '中',
  3: '强',
};
const levelClass = {
  0: 'error',
  1: 'error',
  2: 'warning',
  3: 'success',
};
const levelColor = {
  0: '#ff0000',
  1: '#ff0000',
  2: '#ff7e05',
  3: '#52c41a',
};

export default {
  props: {
    updatePasswordModelVisible: {
      default: false,
    },
    user: {
      required: true,
    },
  },
  data() {
    return {
      form: null,
      loading: false,
      formItemLayout,
      state: {
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000',
      },
      oldPassword: '',
      newPassword: '',
      validateStatus: '',
      help: '',
    };
  },
  computed: {
    show: {
      get: function() {
        return this.updatePasswordModelVisible;
      },
      set: function() {},
    },
    passwordLevelClass() {
      return levelClass[this.state.passwordLevel];
    },
    passwordLevelName() {
      return levelNames[this.state.passwordLevel];
    },
    passwordLevelColor() {
      return levelColor[this.state.passwordLevel];
    },
  },
  methods: {
    isMobile() {
      return this.$store.state.setting.isMobile;
    },
    cancelUpdatePassword() {
      if (this.loading) return;
      this.state.passwordLevelChecked = false;
      this.form.resetFields();
      this.$emit('cancel');
    },
    handleUpdatePassword() {
      if (this.loading) return;
      this.loading = true;
      this.form.validateFields({ force: true }, (err, values) => {
        if (!err) {
          this.$put('user/password', {
            password: encrypt(this.newPassword),
            username: this.user.username,
          }).then(r => {
            const data = r.data;
            if (data === false || (data && Object.prototype.hasOwnProperty.call(data, 'code') && Number(data.code) !== 200)) {
              throw new Error((data && data.msg) || '修改密码失败');
            }
            this.state.passwordLevelChecked = false;
            this.$emit('success');
            this.form.resetFields();
          }).catch(error => {
            this.$message.error((error.response && error.response.data && error.response.data.msg) || error.message || '修改密码失败');
          }).finally(() => {
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      });
    },
    handlePasswordLevel(rule, value, callback) {
      let level = 0;
      value = value || '';
      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++;
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++;
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++;
      }
      this.state.passwordLevel = level;
      this.state.percent = level * 30;
      if (level >= 2) {
        if (level >= 3) {
          this.state.percent = 100;
        }
        callback();
      } else {
        if (level === 0) {
          this.state.percent = 10;
        }
        callback(new Error('密码强度不够'));
      }
    },
    handlePasswordCheck(rule, value, callback) {
      let password = this.form.getFieldValue('password');
      if (!value) return callback();
      if (value && password && value.trim() !== password.trim()) return callback(new Error('两次密码不一致'));
      callback();
    },
    handlePasswordInputClick() {
      if (!this.isMobile()) {
        this.state.passwordLevelChecked = true;
        return;
      }
      this.state.passwordLevelChecked = false;
    },
    handleOldPassowrd(rule, value, callback) {
      if (!value) return callback();
      this.$post2('user/password/check', {
        password: encrypt(value),
        username: this.user.username,
      }).then(r => {
        let valid = r.data;
        if (valid && Object.prototype.hasOwnProperty.call(valid, 'code')) {
          if (Number(valid.code) !== 200) throw new Error(valid.msg || '旧密码校验失败');
          valid = valid.data;
        }
        callback(valid === true ? undefined : new Error('旧密码不正确'));
      }).catch(error => {
        callback(new Error((error.response && error.response.data && error.response.data.msg) || error.message || '旧密码校验失败'));
      });
    },
  },
};
</script>
<style lang="less">
.update-password {
  &.error {
    color: #ff0000;
  }
  &.warning {
    color: #ff7e05;
  }
  &.success {
    color: #52c41a;
  }
}
</style>
